import 'bootstrap/dist/css/bootstrap.css';
import Col from 'react-bootstrap/Col';

const Buttons = () => {
    return (  
    <Col sm="10" id="Navbar">
        <a href="http://ofrweb.pl:57145/#world:0:69:0:39:-2.16:0:0:0:perspective" target='_blank' rel="noreferrer"><button>MAPA</button></a>
        <a href="https://vishop.pl/shop/14027/" target='_blank' rel="noreferrer"><button>SKLEP</button></a>
    </Col>
);
}
 
export default Buttons;